import React, { useRef, useState } from 'react'
import './Contact.css';
import emailjs from '@emailjs/browser';
function Contact() {
   const[done ,setdone] = useState(false);
    const form = useRef();

    const sendEmail = (event) =>{
        event.preventDefault();
        
    emailjs
    .sendForm('service_3swn01n', 'template_ddrby9w', form.current, {
      publicKey: 'aYqQVDIMze9diW4pS',
    })
    .then(
        () => {
            console.log('SUCCESS!')
            setdone(true)
        },
        (error) =>{
            console.log('FAILED..',error.text);
        }
    )
    }
  return (
    <div className="contact-form" >
      {/* left side copy and paste from work section */}
      <div className="w-left">
        <div className="awesme">
          {/* darkMode */}
          <span>Get in Touch</span>
          <span>Contact me</span>
          <div
            className="blur s-blur1"
            style={{ background: "#ABF1FF94" }}
          ></div>
        </div>
      </div>
      {/* right side form */}
      <div className="c-right" id="contact">
        <form ref={form} onSubmit={sendEmail}>
          <input type="text" name="user_name" className="user"  placeholder="Name"/>
          <input type="email" name="user_email" className="user" placeholder="Email"/>
          <textarea name="message" className="user" placeholder="Message"/>
          <input type="submit" value="Send" className="button"/>
          <span>{done && "Thanks for Contacting me"}</span> 
          <div
            className="blur c-blur1"
            style={{ background: "var(--purple)" }}
          ></div>
        </form>
      </div>
    </div>
  );
};


export default Contact